var React = require('react');

function MobileAndroidAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M272 0H48A48 48 0 0 0 0 48v416a48 48 0 0 0 48 48h224a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-64 452a12 12 0 0 1-12 12h-72a12 12 0 0 1-12-12v-8a12 12 0 0 1 12-12h72a12 12 0 0 1 12 12zm64-80a12 12 0 0 1-12 12H60a12 12 0 0 1-12-12V60a12 12 0 0 1 12-12h200a12 12 0 0 1 12 12z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M272 372a12 12 0 0 1-12 12H60a12 12 0 0 1-12-12V60a12 12 0 0 1 12-12h200a12 12 0 0 1 12 12z","className":"fa-primary","key":2})]);
}

MobileAndroidAlt.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = MobileAndroidAlt;

MobileAndroidAlt.default = MobileAndroidAlt;
